document.addEventListener('DOMContentLoaded', function () {
  // Add drag functionality to all slideshows
  document.querySelectorAll('slideshow-component').forEach(function (slideshow) {
    const slider = slideshow.querySelector('.slider');
    if (!slider) return;

    // Skip for mobile devices as they already have touch scrolling
    if (window.innerWidth <= 749) return;

    let isDragging = false;
    let startX = 0;
    let startScrollLeft = 0;
    let autoplayInterval = null;

    // Store original autoplay state
    const hasAutoplay = slideshow.dataset.autoplay === 'true';

    // Mouse down event - start dragging
    slider.addEventListener('mousedown', function (e) {
      isDragging = true;
      slider.classList.add('grabbing');
      startX = e.pageX;
      startScrollLeft = slider.scrollLeft;

      // Pause autoplay if it's running
      if (hasAutoplay) {
        clearInterval(autoplayInterval);
      }
    });

    // Mouse move event - perform dragging
    slider.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      e.preventDefault();
      const x = e.pageX;
      const walk = x - startX;
      slider.scrollLeft = startScrollLeft - walk;
    });

    // End dragging function
    function endDrag() {
      if (!isDragging) return;
      isDragging = false;
      slider.classList.remove('grabbing');

      // Snap to nearest slide
      const slideWidth = slider.querySelector('.slider__slide').offsetWidth;
      const scrollPosition = slider.scrollLeft;
      const slideIndex = Math.round(scrollPosition / slideWidth);

      slider.scrollTo({
        left: slideIndex * slideWidth,
        behavior: 'smooth',
      });

      // Update the active control button if available
      const controlButtons = slideshow.querySelectorAll('.slider-counter__link');
      if (controlButtons.length) {
        controlButtons.forEach((button, index) => {
          if (index === slideIndex) {
            button.classList.add('slider-counter__link--active');
            button.setAttribute('aria-current', true);
          } else {
            button.classList.remove('slider-counter__link--active');
            button.removeAttribute('aria-current');
          }
        });
      }

      // Resume autoplay if it was active
      if (hasAutoplay) {
        const slideshowComponent = slideshow.closest('slideshow-component');
        if (slideshowComponent && typeof slideshowComponent.play === 'function') {
          slideshowComponent.play();
        }
      }
    }

    // Mouse up event - end dragging
    slider.addEventListener('mouseup', endDrag);

    // Mouse leave event - end dragging
    slider.addEventListener('mouseleave', endDrag);
  });
});
